<div
  class="intervals-track"
  [style.width]="timelineTrackWidth()"
  [style.left]="timelineTrackLeft()"
>
  @for (segment of intervalSegments(); track segment.interval.id + '-' + $index) {
    <span
      class="interval-segment"
      [style.width.px]="segment.widthPx"
      [style.background-color]="colorService.getColor(segment.interval.value)"
      [style.--elapsed-percent]="segment.elapsedPercent + '%'"
    ></span>
  }
</div>
<span class="playhead" [style.left]="timelinePlayheadLeft()"></span>
